import styled, { css } from 'styled-components'
import PhoneInput from 'react-phone-input-2'

import FormLabel from '../FormLabel'

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-flow: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled(FormLabel)`
  margin-bottom: 5px;
`

export const Input = styled(PhoneInput)<{
  $isDisabled?: boolean
}>`
  width: 100%;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
    `};

  input {
    ${({ theme }) => theme.textStyles.text};

    &::placeholder {
      color: grey;
    }
  }
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: grey;
  margin-top: 5px;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 5px;
`
